var React = require('react');

function BulleNav (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M191.635,119.407c-70.819-7.392-90.112,57.424-139.861,11.855C12.463,94.558,67.082,25.02,96.744,15.252\r\n\t\tc12.298-3.602,37.363-1.78,49.348,11.541c16.608,17.14,5.358,41.104,12.539,59.062C165.103,102.147,174.557,117.63,191.635,119.407\r\n\t\tz"})));
}

BulleNav.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 200 200","xmlSpace":"preserve"};

module.exports = BulleNav;

BulleNav.default = BulleNav;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/bulle-nav.svg
// module id = 374
// module chunks = 0